var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJuice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Juice") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "_67---Juice",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "juice",
    "data-name": "juice"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.396,19.126l-30.792,0c0,0 2.496,27.104 3.208,34.837c0.107,1.154 1.075,2.037 2.234,2.037l19.908,0c1.159,0 2.127,-0.883 2.234,-2.037c0.712,-7.733 3.208,-34.837 3.208,-34.837Z",
    fill: "none",
    stroke: "#444f58",
    strokeWidth: "2px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.026,14.706c0,-1.238 -1.004,-2.242 -2.242,-2.242c-6.467,0 -25.101,0 -31.568,0c-1.238,0 -2.242,1.004 -2.242,2.242c0,0.702 0,1.476 0,2.177c0,1.239 1.004,2.243 2.242,2.243c6.467,0 25.101,0 31.568,0c1.238,0 2.242,-1.004 2.242,-2.243c0,-0.701 0,-1.475 0,-2.177Z",
    fill: "none",
    stroke: "#444f58",
    strokeWidth: "2px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.375,12.464l-24.75,0l0,-2.221c0,-1.239 1.004,-2.243 2.242,-2.243c4.705,0 15.561,0 20.266,0c1.238,0 2.242,1.004 2.242,2.243c0,1.112 0,2.221 0,2.221Z",
    fill: "none",
    stroke: "#444f58",
    strokeWidth: "2px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.25,33.474c2.868,1.655 1.352,9.658 -0.304,12.526c-1.656,2.868 -5.328,3.852 -8.196,2.196c-2.868,-1.656 -3.852,-5.328 -2.196,-8.196c1.656,-2.868 7.828,-8.182 10.696,-6.526Z",
    fill: "none",
    stroke: "#444f58",
    strokeWidth: "2px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.75,41.268c0.956,0.552 1.284,1.776 0.732,2.732c-0.552,0.956 -1.776,1.284 -2.732,0.732c-0.956,-0.552 -1.284,-1.776 -0.732,-2.732c0.552,-0.956 1.776,-1.284 2.732,-0.732Z",
    fill: "none",
    stroke: "#444f58",
    strokeWidth: "2px"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuice);
export default __webpack_public_path__ + "static/media/juice.3003109078ee248e1593eedcae919862.svg";
export { ForwardRef as ReactComponent };